let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("30jIn")).then(() => parcelRequire('2zrZa'));